<div class="navbar">
  <nav style="width: 100%;">
    <img style="width: 2%; float: left" src="../../../assets/images/Toyota_logo.png" class="toyota-logo"
      alt="Toyota Logo" />

    <span style="width: 4%; float: left" class="project-heading">
      LIOS
    </span>

    <mat-tab-group (selectedIndexChange)="onTabClick($event)" class="remove-border-bottom header-gap"
      style="padding-left: 6%; float: left" color="warn" animationDuration="0ms" [selectedIndex]="selected.value">
      <mat-tab style="width: 2%">
        <ng-template mat-tab-label>
          <a class="home" class="navbar-brand pl-3 pr-3" [ngClass]="highlightHome ? 'homeactive' : 'homeinactive'"
            (click)="navigate(navlinks.home.home.url); toggler('home')">
            <mat-icon class="user-arrow-down homeGrey" style="font-size: 22px">home</mat-icon>
          </a>
        </ng-template>
      </mat-tab>
      <mat-tab
        *appModuleFga="{moduleName: ['Alarms', 'Allo', 'Company Information Change Request', 'Cost Planning', 'EBOI', 'Exports', 'Forecast Admin Dashboard', 
        'FTOs', 'Group I', 'Master Dock', 'Region Targets', 'Route Management', 'SCNC', 'Task Manager', 'TLMS Send', 'Delayed Dispatch']}">
        <ng-template mat-tab-label>
          <a mat-list-item class="p15" [matMenuTriggerFor]="planningMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">PLANNING</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #planningMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.alarms.url);
                toggler('planning')
              " *appModuleFga="{moduleName: 'Alarms'}">
                Alarms
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.allo.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Allo'}">
                Allo
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigate(navlinks.planning.companyInfoChange.url);
                toggler('planning')
              " *appFga="{featureId: 'Company Information Change Request Approval'}">
                Company Information Change
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.costPlanning.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Cost Planning'}">
                Cost Planning
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.delayedDispatch.url);
                  toggler('planning')
                  " *appModuleFga="{moduleName: 'Delayed Dispatch'}">
                Delayed Dispatch
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.eboi.url); toggler('planning')
                " *appModuleFga="{moduleName: 'EBOI'}">
                EBOI
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.exports.url);
                toggler('planning')
              " *appModuleFga="{moduleName: 'Exports'}">
                Exports
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.forecastAdmin.url);
                  toggler('planning')
                " *appFga="{featureId: 'Forecast Admin Dashboard'}">
                Forecast Admin Dashboard
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.fto.url); toggler('planning')
                " *appModuleFga="{moduleName: 'FTOs'}">
                FTOs
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.group1.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Group I'}">
                Group I
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.dashboard.url);
                  toggler('planning')
                " *appFga="{featureId: 'Manage Periods'}">
                Manage Periods
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.masterDock.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Master Dock'}">
                Master Dock
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.regionTargets.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'Region Targets'}">
                Region Targets
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.planning.scnc.url); toggler('planning')
                " *appModuleFga="{moduleName: 'SCNC'}">
                SCNC
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.planning.taskManager.url);
                toggler('planning')
              " *appModuleFga="{moduleName: 'Task Manager'}">
                Task Manager
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.planning.tlmsSend.url);
                  toggler('planning')
                " *appModuleFga="{moduleName: 'TLMS Send'}">
                TLMS Send
              </button>
            </mat-menu>
          </a>
        </ng-template>
      </mat-tab>
      <mat-tab *appModuleFga="{moduleName: ['AET', 'Company Information Search',
      'Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary',
      'Trailer Load Diagrams', 'US MX Routes', 'Window Times', 'Returns Reload']}">
        <ng-template mat-tab-label>
          <a mat-list-item class="p15" [matMenuTriggerFor]="operationsMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">OPERATIONS</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #operationsMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                  navigateExternalUrl(navlinks.operations.aet.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'AET'}">
                AET
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.companyInfo.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'Company Information Search'}">
                Company Information
              </button>
              <button class="menu-items-text" mat-menu-item
                *appModuleFga="{moduleName: ['Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary']}"
                (click)="
                  navigate(navlinks.operations.lpBilling.url);
                  toggler('operations')
                ">
                LP Billing
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.operations.trailerLoadDiagrams.url); toggler('operations')
                " *appModuleFga="{moduleName: 'Trailer Load Diagrams'}">
                Trailer Load Diagrams
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.uxmxroutes.url); toggler('operations')
                " *appModuleFga="{moduleName: 'US MX Routes'}">
                US MX Routes
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.wtResolution.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'Window Times'}">
                Window Times
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.operations.returnsReload.url);
                  toggler('operations')
                " *appModuleFga="{moduleName: 'Returns Reload'}">
                Returns Reload
              </button>
            </mat-menu>
          </a>
        </ng-template>
      </mat-tab>
      <mat-tab *appModuleFga="{moduleName: ['Schedule Dashboard', 'Reports']}">
        <ng-template mat-tab-label>
          <a mat-list-item class="p15" [matMenuTriggerFor]="reportingMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">REPORTING</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #reportingMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrl(navlinks.reporting.scheduleDashboard.url);
                  toggler('reporting')
                " *appModuleFga="{moduleName: 'Schedule Dashboard'}">
                Job Scheduler
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                navigateExternalUrlNewWin(navlinks.reporting.reports.url); toggler('reporting')
                " *appModuleFga="{moduleName: 'Reports'}">
                Reports
              </button>
            </mat-menu>
          </a>
        </ng-template>
      </mat-tab>
      <mat-tab *appModuleFga="{moduleName: ['Notification Groups', 'APM User']}">
        <ng-template mat-tab-label>
          <a mat-list-item class="p15" [matMenuTriggerFor]="maintenanceMenu">
            <div class="usermenu">
              <div>
                <div class="menu-sub-text">MAINTENANCE</div>
              </div>
              <mat-icon class="menu-arrow-down">expand_more</mat-icon>
            </div>
            <mat-menu class="usermenu" #maintenanceMenu="matMenu">
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.maintenance.notificationGroup.url);
                  toggler('maintenance')
                " *appModuleFga="{moduleName: 'Notification Groups'}">
                Notification Group
              </button>
              <button class="menu-items-text" mat-menu-item (click)="
                  navigate(navlinks.maintenance.permissionManagement.url);
                  toggler('maintenance')
                " *appModuleFga="{moduleName: 'APM User'}">
                Permission Management
              </button>
            </mat-menu>
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

    <mat-nav-list style="float: right" class="inline row-layout">
      <a mat-list-item class="user-details-header" style="height: 40px" [matMenuTriggerFor]="beforeMenu"
        [disableRipple]="true">
        <div class="usermenu">
          <div *ngIf="profileInitials != ''" class="circle">
            {{ profileInitials }}
          </div>
          <mat-icon class="user-icon">account_circle</mat-icon>
          <div>
            <div class="user-sub-text">{{ userName }}</div>
            <div class="user-sub-text-site">{{ " " }}</div>
          </div>
          <mat-icon class="user-arrow-down">expand_more</mat-icon>
        </div>
      </a>

      <mat-menu #beforeMenu="matMenu" xPosition="before" class="usermenu">
        <button mat-menu-item *ngFor="let role of rolesArray" class="user-items-text" style="width: auto; padding: 7px !important">
          {{ role }}
        </button>
        <button (click)="logout()" mat-menu-item class="user-items-text" style="width: auto; padding: 7px !important">
          <mat-icon>logout</mat-icon>
          LOGOUT
        </button>
      </mat-menu>
    </mat-nav-list>
  </nav>
</div>